import { getStorage, setStorage } from '../../utils/stroage/stroage'

import {
  __CACHE_INFO__,
  __THEME_MODE__,
  __SYSTEM_CONFIG__,
  __DICT__,
  __HIDE_BALANCE__,
  __LOCALE__,
  __LOCALE_LIST__
} from '../../utils/stroage/nameSpace'

import {
  SET_THEME_MODE,
  SET_CUSTOMER_VISIBLE,
  SET_CACHE_INFO,
  SET_SYSTEM_CONFIG,
  SET_DICT,
  SET_HIDE_BALANCE,
  SET_LOCALE_POP_VISIBLE,
  SET_CURRENT_LOCALE,
  SET_CONTRACT_TRADE_DETAIL_MESSAGE,
  SET_LOCALE_LIST
} from '../nameSpace'

import { addClass, hasClass, removeClass } from '../../utils/dom'

import {THEME_DARK, THEME_LIGHT, themeModeDefault, themes} from '../../config/theme'

import {
  checkCacheVersionIsRight,
  initStateInCacheHas,
  findTargetUpdateTimeByKey,
  cacheHandler,
  checkCacheVersionWithoutLocaleIsRight,
  isNeedUpdateCacheInfo
} from '../../utils/cache'

import {sysConfigSimpleList, sysCacheRefreshList, i18nLanguageSimpleList} from '../../api/system/system'

export default {
  state: {
    theme: getStorage(__THEME_MODE__) || themeModeDefault,
    systemConfig: initStateInCacheHas(__SYSTEM_CONFIG__),
    dict: initStateInCacheHas(__DICT__),
    cacheInfo: getStorage(__CACHE_INFO__) || null,
    customerVisible: false,
    hideBalance: getStorage(__HIDE_BALANCE__) || null,
    localePopVisible: false,
    contractTradeDetailMessage: {
    },
    currentLocale: getStorage(__LOCALE__) || '',
    localeList: initStateInCacheHas(__LOCALE_LIST__) || null
  },
  mutations: {
    [ SET_CURRENT_LOCALE ] (state, locale) {
      state.currentLocale = locale
      setStorage(__LOCALE__, locale)
    },
    [ SET_CONTRACT_TRADE_DETAIL_MESSAGE ] (state, contractTradeDetailMessage) {
      state.contractTradeDetailMessage = contractTradeDetailMessage
    },
    [ SET_LOCALE_POP_VISIBLE ] (state, localePopVisible) {
      state.localePopVisible = localePopVisible
    },
    [ SET_HIDE_BALANCE ] (state, hideBalance) {
      state.hideBalance = hideBalance
      setStorage(__HIDE_BALANCE__, state.hideBalance)
    },
    [ SET_THEME_MODE ] (state, theme) {
      state.theme = theme
      setStorage(__THEME_MODE__, state.theme)
    },
    [ SET_CUSTOMER_VISIBLE ] (state, customerVisible) {
      state.customerVisible = customerVisible
    },
    [ SET_CACHE_INFO ] (state, cacheInfo) {
      state.cacheInfo = cacheInfo
      setStorage(__CACHE_INFO__, cacheInfo)
    },
    [ SET_SYSTEM_CONFIG ] (state, systemConfig) {
      state.systemConfig = systemConfig
      setStorage(__SYSTEM_CONFIG__, systemConfig)
    },
    [ SET_DICT ] (state, dict) {
      state.dict = dict
      setStorage(__DICT__, dict)
    },
    [ SET_LOCALE_LIST ] (state, localeList) {
      state.localeList = localeList
      setStorage(__LOCALE_LIST__, localeList)
    }
  },
  actions: {
    showLocalePop ({
        commit
    }) {
      return new Promise((resolve) => {
        commit(SET_LOCALE_POP_VISIBLE, true)
        resolve()
      })
    },
    toggleHideBalance ({ commit, state }, { hideBalance } = {}) {
      return new Promise((resolve) => {
        if (hideBalance !== undefined) {
          if (hideBalance === state.hideBalance) {
            return resolve()
          }
        }
        commit(SET_HIDE_BALANCE, !state.hideBalance)
        resolve()
      })
    },
    initCacheInfo ({ commit }, { clearTimer } = {}) {
      return new Promise((resolve, reject) => {
        sysCacheRefreshList({})
          .then(res => {
            if (res.success) {
              if (isNeedUpdateCacheInfo(res.data)) {
                commit(SET_CACHE_INFO, cacheHandler(res.data))
              }
              resolve(res)
            } else {
              reject(new Error(res.message))
            }
          })
          .catch(reject)
      })
    },
    getSysConfigDict ({ commit, state, getters }, { noCache } = {}) {
      return new Promise((resolve, reject) => {
        if (!noCache && checkCacheVersionIsRight(state.systemConfig) && checkCacheVersionIsRight(state.dict)) {
          return resolve()
        } else {
          sysConfigSimpleList({})
            .then(res => {
              if (res.success) {
                const { dict, list } = res.data
                commit(SET_SYSTEM_CONFIG, {
                  ...state.systemConfig,
                  [`value_${getters.locale}`]: {
                    data: list,
                    finishUpdateTime: findTargetUpdateTimeByKey(__SYSTEM_CONFIG__)
                  }
                })
                commit(SET_DICT, {
                  ...state.dict,
                  [`value_${getters.locale}`]: {
                    data: dict,
                    finishUpdateTime: findTargetUpdateTimeByKey(__DICT__)
                  }
                })
                return resolve()
              } else {
                return reject(new Error(res.message))
              }
            })
            .catch(err => {
              console.log(err)
            })
        }
      })
    },
    initThemeMode ({state}) {
      return new Promise(resolve => {
        if (hasClass(document.documentElement, state.theme)) {
          resolve()
        } else {
          addClass(document.documentElement, state.theme)
          resolve()
        }
      })
    },
    showCustomerService ({ commit, state, getters, rootState }) {
      return new Promise((resolve, reject) => {
        if (!rootState.user.token && !getters.PORTAL_systemConfig['unLoginAllowOpenCustomerUrl']) {
          return reject(new Error('Not Allow Open Customer'))
        }
        if (state.customerVisible) return resolve()
        commit(SET_CUSTOMER_VISIBLE, true)
        setTimeout(() => {
          resolve()
        }, 400)
      })
    },
    updateCustomerService ({ commit, state, getters, rootState }, customerVisible) {
      return new Promise((resolve, reject) => {
        if (customerVisible && !rootState.user.token && !getters.PORTAL_systemConfig['unLoginAllowOpenCustomerUrl']) {
          return reject(new Error('Not Allow Open Customer'))
        }
        if (!!state.customerVisible === !!customerVisible) return resolve()
        commit(SET_CUSTOMER_VISIBLE, customerVisible)
        setTimeout(() => {
          resolve()
        }, 400)
      })
    },
    setThemeMode ({commit, state}, themeMode) {
      return new Promise((resolve, reject) => {
        if (!themeMode || !themes.find(themeItm => {
          return themeMode === themeItm.theme
        })) return reject(new Error('没有找到对应的主题色, 请正确选择主题色'))

        let transitionStyleNode = document.createElement('style')
        transitionStyleNode.innerText = 'body * { transition: all .4s linear }'
        document.head.appendChild(transitionStyleNode)

        removeClass(document.body, state.theme)

        commit(SET_THEME_MODE, themeMode)

        addClass(document.body, themeMode)
        setTimeout(() => {
          document.head.removeChild(transitionStyleNode)
        }, 450)
        resolve()
      })
    },
    switchThemeMode ({ commit, state }) {
      let targetMode
      if (state.theme === THEME_DARK) {
        targetMode = THEME_LIGHT
      } else {
        targetMode = THEME_DARK
      }

      let transitionStyleNode = document.createElement('style')
      transitionStyleNode.innerText = 'body * { transition: all .25s }'
      document.head.appendChild(transitionStyleNode)

      removeClass(document.documentElement, state.theme)

      commit(SET_THEME_MODE, targetMode)

      addClass(document.documentElement, targetMode)
      setTimeout(() => {
        document.head.removeChild(transitionStyleNode)
      }, 250)
    },
    /***
     * 获取系统支持的语言列表
     * @param commit
     * @param state
     * @param getters
     * @param noCache
     */
    getSysLocaleList ({ commit, state, getters }, { noCache } = {}) {
      return new Promise((resolve, reject) => {
        if (!noCache && checkCacheVersionWithoutLocaleIsRight(state.localeList)) {
          return resolve()
        }
        i18nLanguageSimpleList({})
          .then((res) => {
            if (res.success) {
              commit(SET_LOCALE_LIST, {
                ...state.localeList,
                value: res.data,
                finishUpdateTime: findTargetUpdateTimeByKey(__LOCALE_LIST__)
              })
              return resolve()
            }
            return reject(new Error(res.message))
          })
          .catch((err) => {
            console.log(err)
            return reject(err)
          })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js